/*eslint-disable*/
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'semantic-ui-react';
import ReadAxios from '../../axiosComponent/read';
const MyCustomerType = ({
    field: { name },
    form: { setFieldValue },
    mappedBillingParty,
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        setloading(true)
        if (props.multiSelect) {
            ReadAxios({
                completeURL: `${process.env.REACT_APP_BASE_URL}/masters/billing_party_types`,
            }).then((response) => {
                if (response.data.resultSet.length > 0) {
                    setcontent(response.data.resultSet)
                    setloading(false)
                }
            })
        }
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            if (props.multiSelect) {
                temp.key = `${object}`.replace(/([A-Z]+)/g, ' $1')
                temp.text = `${object}`.replace(/([A-Z]+)/g, ' $1')
                temp.value = object
                return options[index] = temp
            } else {
                temp.key = object.billingPartyPaymentTypeId
                temp.text = `${object.billingPartyPaymentTypeName}`
                temp.value = props.lrMode ? object.billingPartyPaymentTypeName : object.billingPartyPaymentTypeId
                return options[index] = temp
            }
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        if (props.mode == 'edit') {
            let content = []
            let date = new Date();
            Date.prototype.addDays = function (n) {
                var time = this.getTime();
                var changedDate = new Date(time + (n * 24 * 60 * 60 * 1000));
                this.setTime(changedDate.getTime());
                return this;
            };

            data.value.map((element) => {
                content['billingPartyId'] = props.editId
                content['tbbStartDate'] = moment().format('YYYY-MM-DD HH:mm:ss')
                content['tbbEndDate'] = moment(date.addDays(+30)).format('YYYY-MM-DD HH:mm:ss')
            })
            let payload = { item: content }
            if (mappedBillingParty !== undefined && mappedBillingParty !== null) {
                mappedBillingParty(content, data)
            }
        }
    }
    return (
        <>
            <Dropdown
                selection
                loading={loading ? true : false}
                style={{ width: '100%' }}
                onChange={handleChange}
                options={options}
                noResultsMessage="Search for Result"
                {...props}
            />
        </>
    )
}
export default MyCustomerType